import { StatIcon } from "../../components/StatIcon.js";
import { StatHelpButton } from "./StatHelpButton.js";
import type { StatHelpTopic } from "./statHelp.js";

function deadlineAriaLabel(remaining: number): string {
  if (remaining <= 0) return "期限切れ";
  if (remaining === 1) return "最終フェーズ。いまのフェーズが最後です。";
  return `残り${remaining}フェーズ（いまのフェーズを含む）`;
}

function deadlineCaption(remaining: number): string | null {
  if (remaining <= 0) return "期限切れ";
  if (remaining === 1) return "最終フェーズ";
  return null;
}

export function DeadlinePips({
  remaining,
  changing = false,
  onHelp,
}: {
  remaining: number;
  changing?: boolean;
  onHelp: (topic: StatHelpTopic) => void;
}) {
  const count = Math.max(0, remaining);
  const caption = deadlineCaption(count);
  const className = [
    "foe-turn",
    count === 1 ? "is-last" : "",
    changing ? "is-deadline-change" : "",
  ].filter(Boolean).join(" ");

  return (
    <div className={className} aria-label={deadlineAriaLabel(count)}>
      <span className="meter-label">
        <StatIcon name="deadline" />
        期限
        <StatHelpButton topic="deadline" onHelp={onHelp} />
      </span>
      <span className="deadline-pips" aria-hidden="true">
        {Array.from({ length: count }, (_, i) => (
          <span key={i} className="deadline-pip" />
        ))}
        {caption ? <span className="deadline-last">{caption}</span> : null}
      </span>
    </div>
  );
}
